import { Typography } from '@mui/material';
import { string } from 'prop-types';
import React, { memo } from 'react';

const MessageLabel = ({ className = '', children = null }) => {
  if (!children) return null;
  return (
    <Typography className={className} color="secondary" align="center" variant="caption">
      <span>
        <strong>{children}</strong>
      </span>
    </Typography>
  );
};

MessageLabel.propTypes = {
  children: string,
  className: string,
};

export default memo(MessageLabel);
